module.exports = __webpack_public_path__ + "img/funeng.75660fc2.png";